import { ApiService } from "core/services";

class AuthApi extends ApiService {

  logon(payload) {
    return this.post("logon", payload);
  }

  logoff() {
    return this.post("logoff");
  }

  getSystemStatus() {
    return this.get("system-status");
  }

  changePassword(payload) {
    return this.put("change-password", payload);
  }

  confirmSession() {
    return this.get("confirm-session");
  }

  getOtpInfo() {
    return this.get("otp", null, null, true);
  }

  verifyOtp(payload) {
    return this.post("otp/verify", payload, null, true, payload.trustDevice);
  }

  resendOtp() {
    return this.post("otp/resend", null, null, true);
  }

}

export default AuthApi;
